export const customTooltipUpdate = data => {
    return {
        type: "CUSTOM_TOOLTIP_UPDATE",
        data: data,
    }
}
